
import React from 'react'
import _ from 'lodash'
import { use } from 'xadmin'
import { _t } from 'xadmin-i18n'
import { SchemaForm } from 'xadmin-form'
import { Button, Form } from 'antd'


const InlineGroup = ({ label, meta, input, field, children, option }) => {

  const submitError = option?.submitErrors && Object.values(option.submitErrors)
  const attrs = field.attrs || {}
  const error = meta.touched && (meta.error || meta.submitError) || submitError && submitError.toString()
  const extra = field.description || field.help
  const groupProps = { extra, required: field.required }

  if (error) {
    groupProps['validateStatus'] = 'error'

    groupProps['help'] = error
  }

  const controlComponent = children ? children : (<Input {...input} {...attrs} />)
  return (
    <Form.Item {...groupProps}>
      {React.cloneElement(controlComponent, { inline: true })}
      {field.formText ? <span className="ant-form-text"> {field.formText}</span> : null}
    </Form.Item>
  )
}


const ItemEditFormLayout = (props) => {
  const { children, pristine, invalid, handleSubmit, submitting, submitErrors } = props
  return (
    <Form onSubmit={handleSubmit}>
      {children}
      <Button style={{ marginTop: '-1rem' }} block type="submit" loading={submitting} disabled={pristine || invalid} size="small" onClick={handleSubmit}>{_t('Change')}</Button>
    </Form>
  )
}

const ItemEditForm = props => {
  const { modelDispatch } = use('model')
  const { item, field, value, schema, model, onClose, saveItem } = use('model.save', props)

  const getSchema = () => {
    const formField = _.find(model.form || [], obj => obj && obj.key == field) || { key: field }
    const required = (model.required || []).indexOf(field) >= 0 ? { required: ['value'] } : {}
    return {
      type: 'object',
      properties: {
        value: schema
      },
      form: [{ ...formField, key: 'value' }],
      ...required
    }
  }

  const [formSchema, setFormSchema] = React.useState(getSchema)

  React.useEffect(() => {
    setFormSchema(getSchema())
  }, [model, field, schema])

  return (
    <SchemaForm
      initialValues={{ id: item['id'], value }}
      schema={formSchema}
      option={{
        group: InlineGroup
      }}
      onSubmit={(values) => {
        saveItem({
          id: values.id,
          [field]: values.value
        }, true)
        setTimeout(() => {
          model?.editableFieldsGetItems && modelDispatch({ type: 'GET_ITEMS' })
        }, 500)
      }}
      onSubmitSuccess={() => onClose()}
      component={ItemEditFormLayout} />
  )
}
export default ItemEditForm

